import { css } from '@emotion/css';
import { theme } from 'antd';
import { useMemo } from 'react';

const keyValueVW = (cols: number) => {
  if (cols < 2) {
    return [60, 40];
  }
  return [40, 60 / cols];
};

export const useLabResultCumulativeRendererStyles = (cols: number) => {
  const { token } = theme.useToken();
  return useMemo(() => {
    const [keyVW, valueVW] = keyValueVW(cols);
    return {
      content: css`
        position: relative;
        max-width: 100%;
        overflow-x: auto;
        overflow-y: auto;
        background: ${token.colorBgContainer};
      `,
      groupcell: css`
        position: relative;
        width: 100%;
        height: 4em;
      `,
      grouptitle: css`
        position: absolute;
        top: -3em;
        left: 0;
        width: 100%;
        font-size: 1.3em;
        padding: 30px 0 20px 0;
        z-index: 10;
        overflow: visible;
        white-space: nowrap;
      `,
      firstcolumn: css`
        flex: 0 0 auto;
        padding: ${token.paddingSM}px;
        position: sticky;
        left: 0;
        width: clamp(250px, ${keyVW}vw, 650px);
        z-index: 10;
        background-color: ${token.colorBgContainer};
        // box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1); /* Optional: Schatten für visuellen Effekt */       }

        @media (max-width: ${token.screenLG}px) {
          position: relative;
        }
      `,
      column: css`
        flex: 0 0 auto;
        width: clamp(150px, ${valueVW}vw, 450px);
        padding: ${token.paddingSM}px;
      `,
      ordergroupcell: css`
        padding-bottom: ${token.paddingSM}px;
        border-bottom: 1px solid ${token.colorBorder};
      `,

      ordertitle: css`
        color: ${token.colorTextDisabled};
        font-size: ${token.fontSizeSM}px;
        font-weight: bold;
        text-transform: uppercase;
      `,
      orderentry: css`
        padding-bottom: ${token.paddingSM}px;
        border-bottom: 1px solid ${token.colorBorder};
      `,
      parameter: css`
        padding-bottom: ${token.paddingSM}px;
        border-bottom: 1px dashed ${token.colorBorder};
      `,
      selected: css`
        background: ${token.colorFillTertiary};
      `,
    };
  }, [token, cols]);
};
